import { PricingItem } from "../../../../../../../../model/site";

const paths: Record<PricingItem["buttonType"], JSX.Element> = {
  // two links of a chain
  LINK: (
    <>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </>
  ),
  // the balloon of a conversation with a phone in it
  WHATSAPP: (
    <>
      <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
      <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
    </>
  ),
};

type Props = {
  type: PricingItem["buttonType"];
};

/** Where the button of a plan goes, drawn as outlined strokes like the icons of the types of a form field. */
export const ButtonTypeIcon = ({ type }: Props) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    {paths[type]}
  </svg>
);
